import React, {Component} from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';
import {ListGroup, ListGroupItem} from "reactstrap";
import Checkbox from "components/Checkbox";
import {FormattedMessage} from "react-intl";
import _ from "lodash";

class CheckRows extends Component {
  constructor(props){
    super(props);

    this.onChange = this.onChange.bind(this);
    this.onToggleAll = this.onToggleAll.bind(this);
  }

  onChange(row){
    let {checked} = this.props;

    checked = checked.includes(row) ? checked.filter(r => r !== row) : [...checked, row];

    this.props.onChange(checked);
  }

  onToggleAll() {
    const allChecked = _.isEqual(_.map(this.props.rows, row => row.id).sort(), this.props.checked.sort());

    const checked = allChecked ? [] : _.map(this.props.rows, row => row.id);

    this.props.onChange(checked);
  }

  render() {
    const {checked, rows} = this.props;
    const allChecked = _.isEqual(_.map(rows, row => row.id).sort(), checked.sort());

    return (
      <ListGroup>
        <ListGroupItem className="py-0" onClick={this.onToggleAll}>
          <Checkbox
            text={<FormattedMessage id="checkRows.toggleAll"/>}
            id={'checkbox-rows-all'}
            checked={allChecked}
            tooltip={false}
          />
        </ListGroupItem>
        {Object.values(rows).map(row => {
          return <ListGroupItem className="py-0" key={row.id} onClick={() => this.onChange(row.id)}>
            <Checkbox
              text={<div dangerouslySetInnerHTML={{__html: row.content}} />}
              id={'checkbox-row-' + row.id}
              checked={checked.includes(row.id)}
              tooltip={false}
            />
          </ListGroupItem>
        })}
      </ListGroup>
    );
  }
}

CheckRows.propTypes = {
  questionId: PropTypes.number.isRequired,
  rows: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    content: PropTypes.string.isRequired,
  }).isRequired,).isRequired,
  checked: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
};

function mapStateToProps(state, props) {
  return {
    rows: Object.values(_.map(state.survey.structure.data.questions[props.questionId].rows, id => state.survey.structure.data.rows[id])),
  }
}

export default connect(mapStateToProps)(CheckRows);